import { render } from "./AboutLingBangTechnology.vue?vue&type=template&id=e92aee50&scoped=true"
const script = {}

import "./AboutLingBangTechnology.vue?vue&type=style&index=0&id=e92aee50&scoped=true&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e92aee50"]])

export default __exports__